function p(r) {
  function e(t, l) {
    if (t.component && t.component.proxy)
      l.push(t.component.proxy);
    else if (t.shapeFlag & 16) {
      const u = t.children;
      for (let c = 0; c < u.length; c++)
        e(u[c], l);
    }
  }
  const f = r.$.subTree, o = [];
  return f && e(f, o), o;
}
const i = /* @__PURE__ */ new WeakMap();
function n(r) {
  let e = i.get(r);
  return e || i.set(r, e = /* @__PURE__ */ Object.create(null)), e;
}
function s(r, e, f) {
  if (Array.isArray(e))
    e.forEach((o) => s(r, o, f));
  else {
    const o = n(r);
    (o[e] || (o[e] = [])).push(f);
  }
  return r;
}
function $(r, e, f) {
  const o = (...t) => {
    y(r, e, o), f.call(r, ...t);
  };
  return o.fn = f, s(r, e, o), r;
}
function y(r, e, f) {
  const o = r;
  if (!e)
    return i.set(r, /* @__PURE__ */ Object.create(null)), o;
  if (Array.isArray(e))
    return e.forEach((u) => y(r, u, f)), o;
  const t = n(r), l = t[e];
  return l ? f ? (t[e] = l.filter((u) => !(u === f || u.fn === f)), o) : (t[e] = void 0, o) : o;
}
function h(r, e, ...f) {
  r && r.$emit && r.$emit(e, ...f);
  const o = n(r)[e];
  return o && o.map((t) => t.apply(r, f)), r;
}
function k(r) {
  const e = {
    staticClass: "class",
    staticStyle: "style",
    on: "",
    domProps: "",
    props: "",
    attrs: ""
  };
  function f(t) {
    return typeof t == "string" ? [t] : Object.keys(t).map((l, u) => ({ [l]: Object.values(t)[u] }));
  }
  let o = {};
  for (let t in r)
    e[t] == null && (typeof r[t] == "object" ? o[t] = f(r[t]) : o[t] = r[t]);
  for (let t in r)
    if (e[t] === "")
      if (typeof r[t] == "object")
        for (let l in r[t])
          o[l] = r[t][l];
      else
        o[t] = r[t];
  for (let t in r)
    e[t] && (o[e[t]] = o[e[t]] || [], o[e[t]] = o[e[t]].concat(
      f(r[t])
    ));
  return o;
}
export {
  p as $children,
  h as $emit,
  y as $off,
  s as $on,
  $ as $once,
  k as plantRenderPara
};
